module.exports = __webpack_public_path__ + "03_long_yellow.c3c87132.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/03_long_yellow.png
// module id = Qfqe
// module chunks = 0